import { styled } from "styled-components";
import { useVideoStore } from "../../shared/zustand/video";
import React from "react";

export type Subtitle = {
  start: number;
  end: number;
  text: string;
};

interface SubtitleDisplayProps {
  subtitles: Subtitle[];
}

export const SubtitleDisplay: React.FC<SubtitleDisplayProps> = ({
  subtitles,
}) => {
  const currentTime = useVideoStore((state) => state.currentTime);

  const currentSubtitle = subtitles.find(
    (s) => currentTime >= s.start && currentTime <= s.end
  );

  return <SubtitleWrap>{currentSubtitle?.text || ""}</SubtitleWrap>;
};

const SubtitleWrap = styled.div`
  max-width: 85%;
  margin-bottom: 40px;
  margin-top: 10px;
  text-align: center;
  font-size: 18px;
  color: "rgba(0,0,0,0.6)";
  padding: "8px 12px";
`;
